export default __webpack_public_path__ + "static/media/2.18d51d22.svg";